<template>
  <div>
    <b-row>
      <b-col>
        <h2>{{ $t('homePage') }}</h2>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col lg="3">
        <b-card class="card-statistic bg-purple">
          <b-card-body>
            <b-row>
              <b-col>
                <img src="@/assets/img/statistics.svg" />
                <span>5456,8</span>
                <p>{{ $t('agro_gdp') }}</p>
              </b-col>
              <b-col cols="2">
                <b-icon-arrow-right />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="3">
        <b-card class="card-statistic bg-pink">
          <b-card-body>
            <b-row>
              <b-col>
                <img src="@/assets/img/money.svg" />
                <span>341.9</span>
                <p>{{ $t('agro_investment') }}</p>
              </b-col>
              <b-col cols="2">
                <b-icon-arrow-right />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="3">
        <b-card class="card-statistic bg-blue">
          <b-card-body>
            <b-row>
              <b-col>
                <img src="@/assets/img/plant.svg" />
                <span>1809,9</span>
                <p>{{ $t('agro_people') }}</p>
              </b-col>
              <b-col cols="2">
                <b-icon-arrow-right />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="3">
        <b-card class="card-statistic bg-gray">
          <b-card-body>
            <b-row>
              <b-col>
                <img src="@/assets/img/map2.svg" height="48" />
                <span>4780,6</span>
                <p>{{ $t('agro_suitable_land') }}</p>
              </b-col>
              <b-col cols="2">
                <b-icon-arrow-right />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col lg="12">
        <div id="view1"></div>
      </b-col>
      <b-col lg="12">
        <div id="view2"></div>
      </b-col>
      <b-col lg="12">
        <div id="view3"></div>
      </b-col>
      <b-col lg="12">
        <div id="view4"></div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Tableau from '../components/Tableau.vue';

export default {
  components: { Tableau },
  data: () => ({
    url1_az: "https://public.tableau.com/views/MsgulluqUDM_last_version/UDMMulluq?:language=en-GB&publish=yes&:display_count=n&:origin=viz_share_link",
    url2_az: "https://public.tableau.com/views/Bitkiilik_mumi_/Sheet1?:language=en-GB&publish=yes&:display_count=n&:origin=viz_share_link",
    url3_az: "https://public.tableau.com/views/Bitkiilikrayonlarzr/Dashboard1?:language=en-GB&publish=yes&:display_count=n&:origin=viz_share_link",
    url4_az: "https://public.tableau.com/views/Heyvandarlq_ready/Heyvanlarnsay?:language=en-GB&:display_count=n&:origin=viz_share_link",
    url1_en: "https://public.tableau.com/views/gdpemployment_lastversion/GDPEmployment?:language=en-GB&publish=yes&:display_count=n&:origin=viz_share_link",
    url2_en: "https://public.tableau.com/views/Plant-Growinggeneral/Plant-Growinggeneral?:language=en-GB&publish=yes&:display_count=n&:origin=viz_share_link",
    url3_en: "https://public.tableau.com/views/Plant-Growingbyregion/Plant-Growing?:language=en-GB&publish=yes&:display_count=n&:origin=viz_share_link",
    url4_en: "https://public.tableau.com/shared/9YQWTPZK9?:display_count=n&:origin=viz_share_link",
    apiUrl: 'https://public.tableau.com/javascripts/api/tableau-2.2.2.min.js',
    viz1: {},
    viz2: {},
    viz3: {},
    viz4: {},
  }),
  created() {
    this.$eventHub.$on("localeChanged", (err) => {
      location.reload();
    });
  },
  methods: {
    initViz() {
      let options = {
        height: 800,
        width: '100%',
        hideTabs: true,
        hideToolbar: true
      };

      this.viz1 = new window.tableau.Viz(document.getElementById('view1'), this.$i18n.locale === "az" ? this.url1_az : this.url1_en, options);
      this.viz2 = new window.tableau.Viz(document.getElementById('view2'), this.$i18n.locale === "az" ? this.url2_az : this.url2_en, options);
      this.viz2 = new window.tableau.Viz(document.getElementById('view3'), this.$i18n.locale === "az" ? this.url3_az : this.url3_en, options);
      this.viz2 = new window.tableau.Viz(document.getElementById('view4'), this.$i18n.locale === "az" ? this.url4_az : this.url4_en, options);
    },

    disposeAll() {
      this.viz1.dispose()
      this.viz2.dispose()
      this.viz3.dispose()
      this.viz4.dispose()
    }
  },
  mounted() {
    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', this.apiUrl);
    this.tableauScript = document.head.appendChild(recaptchaScript);
    window.addEventListener('load', () => {
      this.initViz();
    })
  },
  beforeDestroy() {
    this.disposeAll();
  }
};
</script>
